import React, { useState, useEffect } from 'react';
import './Countdown.css';
import { useTranslation } from 'react-i18next';

const Countdown = () => {
    const { t } = useTranslation();
    const calculateTimeLeft = () => {
        const difference = +new Date('2026-09-19T17:00:00') - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearTimeout(timer);
    });

    return (
        <div className="countdown">
            {Object.keys(timeLeft).length ? (
                <>
                    <div className="countdown-item">
                        <div className="countdown-value">{timeLeft.days}</div>
                        <div className="countdown-unit">{t('days')}</div>
                    </div>
                    <div className="countdown-bottom-row">
                        <div className="countdown-item">
                            <div className="countdown-value">{timeLeft.hours}</div>
                            <div className="countdown-unit">{t('hours')}</div>
                        </div>
                        <div className="countdown-item">
                            <div className="countdown-value">{timeLeft.minutes}</div>
                            <div className="countdown-unit">{t('minutes')}</div>
                        </div>
                        <div className="countdown-item">
                            <div className="countdown-value">{timeLeft.seconds}</div>
                            <div className="countdown-unit">{t('seconds')}</div>
                        </div>
                    </div>
                </>
            ) : (
                <span>{t('time_up')}</span>
            )}
        </div>
    );
}

export default Countdown;

